import { useQuery } from "@tanstack/react-query";
import { fetchRansomware } from "@/utils/dashboardFetch";

export const useRansomwareQuery = () => {
    return useQuery({
        queryKey: ['ransomware'],
        queryFn: fetchRansomware,
        staleTime: 1000 * 60 * 15, // 15 minutes
    });
};
